import { Icon } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import styles from './styles.module.scss'

type BlockContactModalContentProps = {
  contact?: Contact
}

export const BlockContactModalContent = ({ contact }: BlockContactModalContentProps) => {
  const isUnknowContact = !contact || contact.isUnknownContact

  return (
    <div className={styles.modalContent}>
      <div className={styles.iconWrapper}>
        <div className={styles.icon}>
          <Icon icon='alert' />
        </div>
      </div>
      <div className={styles.title}>{isUnknowContact ? 'Block number?' : 'Block contact?'}</div>
      <div className={styles.description}>
        {isUnknowContact
          ? 'Block this number and mark it as spam. You won’t receive calls or messages.'
          : 'You won’t be notified if any new messages come from this contact'}
      </div>
    </div>
  )
}
